const __WEBPACK_NAMESPACE_OBJECT__ = require("rc-pagination/es/locale/en_US");